import React from 'react';
// import { useNavigate } from 'react-router-dom';
import './events.css'; // Reuse existing styling

const SlamFestInfo = () => {
 // const navigate = useNavigate();

  // const handleNext = () => {
  //   navigate('/eventswithschools');
  // };


  return (
    <div className="slamfest-info-container">
<h2>Welcome to Slam Fest 2025, starting from the 7th July onwards!</h2>
      <p>
        Get ready for an inter-school showdown filled with fun, sportsmanship, and excitement! Here's everything you need to know:
      </p>

      <h2>What is SLAM FEST?</h2>
      <ul>
        <li><strong>Smaaash S.L.A.M. Fest</strong> (Skill - Learn - Achieve - Master), an Inter-School Championship, brings together the best young talent from 32 schools in Mumbai.</li>
        <li>This 20-day championship features engaging games, combining mental challenges with physical sports.</li>
        <li>It’s a chance for students to start their journey in mastering different sports—future champions may rise here!</li>
      </ul>

      <h2>Rules for Participants</h2>
      <ul>
        <li>Each participant must compete in one Mind Sport (Chess or Rubik’s Cube) and one Physical Challenge (Cricket or Bowling).</li>
        <li>Official nomination from the school and valid school ID card is mandatory.</li>
        <li>Report at least 30 minutes before your scheduled game time.</li>
        <li>Maintain discipline and fair play—misconduct leads to disqualification.</li>
        <li>Game equipment will be provided; personal gear allowed with prior approval.</li>
        <li>Judges' decisions are final—no appeals will be entertained.</li>
        <li>School uniform must be worn during the event.</li>
        <li>Participation implies consent for event photography and media coverage.</li>
      </ul>

      <h2>Flow of Event – S.L.A.M. Fest</h2>
      <ul>
        <li><strong>Total Participating Schools:</strong> 32 Schools</li>
        <li><strong>Event Duration:</strong> 16 Days</li>
        <li><strong>Schedule:</strong> 2 Schools Participating Each Day</li>
      </ul>

      <h2>Event Categories</h2>
      <ul>
        <li><strong>Mind Sport</strong></li>
        <ul>
          <li>Chess – 50 Participants from each school</li>
          <li>Rubik’s Cube – 50 Participants from each school</li>
        </ul>
        <li><strong>Physical Sport</strong></li>
        <ul>
          <li>Bowling – 50 Participants selected from Mind Sport categories</li>
          <li>Cricket – 50 Participants selected from Mind Sport categories</li>
        </ul>
      </ul>
        <p> By participating, you agree to abide by all rules set by the organizing committee. Let's make this Slam Fest unforgettable! </p>
     {/* <button className="next-button" onClick={handleNext}>
        Next
      </button> */}
    </div>
  );
};

export default SlamFestInfo;
